/*
 * Authors: mariushirjanu
 * Created: 06/09/2022
 */
import { Component, OnInit } from '@angular/core';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../shared/formly/ga-formly.service';
import { GaValidateService } from '../../../shared/formly/ga-validate.service';
import { BUTTON_SAVE, DefaultFormDialogComponent } from '../../../shared/message/dialogs/default-form-dialog.component';
import { TranslationService } from '../../../shared/translation/translation.service';
import { UntypedFormControl } from '@angular/forms';
import { IChangePasswordResponse, UserProfileDataService } from '../userprofile-data.service';

export interface IChangePassword {
  oldPassword:string;
  newPassword:string;
  confirmPassword:string;
}

@Component({
  selector: 'change-password',
  templateUrl: '../../../shared/message/dialogs/default-form-dialog.html'
})
export class ChangePasswordComponent extends DefaultFormDialogComponent implements OnInit {
  public model:IChangePassword = <any>{};

  constructor(
    private formlyService:GaFormlyService,
    private userProfileDataService:UserProfileDataService,
    validateService:GaValidateService,
    translationService:TranslationService
  ) {
    super(validateService, translationService);
  }

  public ngOnInit():void {
    super.ngOnInit();
    this.buttons = [ {
      id: BUTTON_SAVE,
      label: this.translationService.instant('APP.USER_PROFILE.USER_INFO.UPDATE_PASSWORD'),
      className: 'btn btn-success',
      onClick: this.save,
      busy: this.saving
    }, {
      label: 'APP.USER_PROFILE.USER_INFO.DO_NOT_UPDATE_PASSWORD',
      className: 'btn btn-danger',
      onClick: () => this.onCancel.emit()
    } ];

    this.fields = this.createFields();
  }

  private createFields():IExtraFieldConfigurationObject[] {
    const fields:IExtraFieldConfigurationObject[] = [];
    const labelClass:string = 'col-md-4';
    const valueClass:string = 'col-md-8';

    const passwordField:IExtraFieldConfigurationObject = this.formlyService.anInput('newPassword', 'APP.USER_PROFILE.USER_INFO.NEW_PASSWORD')
      .isRequired()
      .withLabelClass(labelClass)
      .withValueClass(valueClass)
      .withPlaceholder()
      .withInputType('password')
      .withMinLength(6)
      .build();

    fields.push(
      this.formlyService.anInput('oldPassword', 'APP.USER_PROFILE.USER_INFO.OLD_PASSWORD')
        .isRequired()
        .withLabelClass(labelClass)
        .withValueClass(valueClass)
        .withPlaceholder()
        .withInputType('password')
        .build(),

      passwordField,
      this.formlyService.anInput('confirmPassword', 'APP.USER_PROFILE.USER_INFO.CONFIRM_PASSWORD')
        .isRequired()
        .withLabelClass(labelClass)
        .withValueClass(valueClass)
        .withPlaceholder()
        .withInputType('password')
        .withMinLength(6)
        .withExtraOptions({
          validators: {
            format: {
              expression: (control:UntypedFormControl) => this.model?.newPassword === control?.value,
              message: this.translationService.instant('APP.ACCESS.PASSWORD.PASSWORDS_NOT_MATCH')
            }
          }
        })
        .build()
    );
    return fields;
  }

  public save = ():void => {
    this.validateService.validateFields(this.fields, this.model, true)
      .then(() => {
        this.saveButtonBusy = true;
        this.userProfileDataService.changePassword(this.model.oldPassword, this.model.newPassword)
          .then((response:IChangePasswordResponse) => {
            if (response.token) {
              this.onSave.emit(response.token);
            }
          })
          .finally(() => {
            this.saveButtonBusy = false;
          });
      });
  };
}